import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

type GeoTestedCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function GeoTestedCheckbox({ checked, onChange }: GeoTestedCheckboxProps) {
  return (
    <div className="flex items-start space-x-3">
      <Checkbox
        id="geo-tested"
        checked={checked}
        onCheckedChange={(checked) => onChange(checked === true)}
        className="mt-0.5"
      />
      <div className="grid gap-1 leading-none">
        <Label htmlFor="geo-tested" className="text-sm font-medium cursor-pointer">
          I tested this prompt
        </Label>
        <p className="text-xs text-muted-foreground">
          Mark if you've verified this prompt works as expected
        </p>
      </div>
    </div>
  );
}
